/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_No_PermissionsInputs */

const en_admin_permissions_no_permissions = /** @type {(inputs: Admin_Permissions_No_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No permissions defined yet`)
};

const zh_admin_permissions_no_permissions = /** @type {(inputs: Admin_Permissions_No_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂未定义权限`)
};

/**
* | output |
* | --- |
* | "No permissions defined yet" |
*
* @param {Admin_Permissions_No_PermissionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_no_permissions = /** @type {((inputs?: Admin_Permissions_No_PermissionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_No_PermissionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_no_permissions(inputs)
	return zh_admin_permissions_no_permissions(inputs)
});
export { admin_permissions_no_permissions as "admin.permissions.no_permissions" }